(() => {
  if (matchMedia('(max-width:989px)').matches) return;
  if (window.__sharpSafariEggRestore20260913b) return;
  window.__sharpSafariEggRestore20260913b = true;

  const ua = navigator.userAgent || '';
  const isSafari =
    /Safari/i.test(ua) &&
    !/(Chrome|CriOS|Chromium|Edg|EdgiOS|OPR|OPiOS|SamsungBrowser|FxiOS|Firefox)/i.test(ua);
  const hasTouch = navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
  const isMobileTouch = hasTouch && window.matchMedia('(max-width: 1199px)').matches;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setupMobilePullRefresh = () => {
    if (!isMobileTouch) return;

    if (typeof window.__sharpMobilePullRefreshCleanup === 'function') {
      window.__sharpMobilePullRefreshCleanup();
      window.__sharpMobilePullRefreshCleanup = null;
    }

    if (typeof window.__sharpCrossBrowserEggCleanup === 'function') {
      window.__sharpCrossBrowserEggCleanup();
      window.__sharpCrossBrowserEggCleanup = null;
    }

    const html = document.documentElement;
    html.classList.remove('sharp-chrome-easter-egg');
    html.classList.add('sharp-mobile-pull-refresh');
    document.getElementById('sharp-cross-browser-overscroll-style')?.remove();

    const wrapper = document.querySelector('.header-wrapper');
    const header = wrapper?.querySelector('header') || document.querySelector('header.header');
    const logo = header?.querySelector('.header__heading-logo-wrapper, .header__heading-link');
    if (!wrapper || !header || !logo) return;

    let reveal = document.querySelector('.sharp-overscroll-easter-egg');
    if (!reveal) {
      reveal = document.createElement('div');
      reveal.className = 'sharp-overscroll-easter-egg';
      reveal.setAttribute('aria-hidden', 'true');
      reveal.textContent = 'PHILIPPIANS 4:13';
      wrapper.prepend(reveal);
    }

    let style = document.getElementById('sharp-mobile-pull-refresh-style');
    if (!style) {
      style = document.createElement('style');
      style.id = 'sharp-mobile-pull-refresh-style';
      style.textContent = `
        html.sharp-mobile-pull-refresh,
        html.sharp-mobile-pull-refresh body {
          overscroll-behavior-y: none !important;
        }
        .header-wrapper { overflow: visible !important; }
        html.sharp-mobile-pull-refresh .sharp-overscroll-easter-egg {
          position: fixed !important;
          top: var(--sharp-egg-top, 0px) !important;
          left: var(--sharp-egg-left, 50%) !important;
          z-index: 12 !important;
          transform: translate(-50%, calc(-18px + var(--sharp-egg-travel, 0px))) scale(var(--sharp-egg-scale, .96)) !important;
          opacity: var(--sharp-egg-opacity, 0) !important;
          visibility: hidden !important;
          pointer-events: none !important;
          white-space: nowrap !important;
          color: var(--sharp-easter-egg-color, #111) !important;
          mix-blend-mode: normal !important;
          background: rgba(255, 255, 255, .98) !important;
          border: 1px solid rgba(17, 17, 17, .10) !important;
          border-radius: 999px !important;
          box-shadow: 0 7px 22px rgba(0, 0, 0, .16) !important;
          padding: 7px 11px 6px !important;
          font-family: var(--font-heading-family, Arial, sans-serif) !important;
          font-size: 11.5px !important;
          font-weight: 800 !important;
          line-height: 1 !important;
          letter-spacing: .14em !important;
          text-transform: uppercase !important;
          transition:
            opacity 170ms ease,
            transform 250ms cubic-bezier(.22,.61,.36,1),
            visibility 0s linear 260ms !important;
          will-change: opacity, transform;
        }
        html.sharp-mobile-pull-refresh .sharp-overscroll-easter-egg.is-pulling {
          visibility: visible !important;
          transition:
            opacity 55ms linear,
            transform 60ms linear,
            visibility 0s linear 0s !important;
        }
        @media (prefers-reduced-motion: reduce) {
          html.sharp-mobile-pull-refresh .sharp-overscroll-easter-egg {
            transition: none !important;
          }
        }
      `;
      document.head.appendChild(style);
    }

    let pull = 0;
    let touchStartY = 0;
    let trackingTouch = false;
    let releaseTimer = 0;

    /* Intentionally requires a deliberate, deep pull so the verse stays an easter egg. */
    const deadZone = 52;
    const pullFactor = 0.55;
    const maxPull = 92;
    const revealThreshold = 74;

    const positionReveal = () => {
      const headerRect = header.getBoundingClientRect();
      const logoRect = logo.getBoundingClientRect();
      reveal.style.setProperty('--sharp-egg-left', `${Math.round(logoRect.left + (logoRect.width / 2))}px`);
      reveal.style.setProperty('--sharp-egg-top', `${Math.round(headerRect.bottom + 6)}px`);
    };

    const renderPull = (distance) => {
      pull = Math.max(0, Math.min(maxPull, distance));
      const progress = Math.min(1, pull / revealThreshold);
      const eased = 1 - Math.pow(1 - progress, 1.8);
      const visibleProgress = Math.max(0, (progress - .30) / .70);
      const opacity = reducedMotion.matches
        ? (progress >= .78 ? 1 : 0)
        : Math.min(1, visibleProgress);

      reveal.classList.add('is-pulling');
      reveal.style.setProperty('--sharp-egg-opacity', opacity.toFixed(3));
      reveal.style.setProperty('--sharp-egg-travel', `${Math.round(eased * 20)}px`);
      reveal.style.setProperty('--sharp-egg-scale', `${(.96 + (eased * .04)).toFixed(3)}`);
    };

    const release = () => {
      window.clearTimeout(releaseTimer);
      reveal.style.setProperty('--sharp-egg-opacity', '0');
      reveal.style.setProperty('--sharp-egg-travel', '0px');
      reveal.style.setProperty('--sharp-egg-scale', '.96');
      pull = 0;
      releaseTimer = window.setTimeout(
        () => reveal.classList.remove('is-pulling'),
        reducedMotion.matches ? 0 : 270
      );
    };

    const onTouchStart = (event) => {
      if (event.touches.length !== 1 || window.scrollY > 1) {
        trackingTouch = false;
        return;
      }

      touchStartY = event.touches[0].clientY;
      trackingTouch = true;
      pull = 0;
      positionReveal();
    };

    const onTouchMove = (event) => {
      if (!trackingTouch || event.touches.length !== 1) return;

      if (window.scrollY > 1) {
        trackingTouch = false;
        if (pull > 0) release();
        return;
      }

      const delta = event.touches[0].clientY - touchStartY;
      if (delta <= 0) {
        if (pull > 0) release();
        return;
      }

      const activeDistance = Math.max(0, (delta - deadZone) * pullFactor);
      if (activeDistance <= 0) return;

      if (event.cancelable) event.preventDefault();
      renderPull(activeDistance);
    };

    const onTouchEnd = () => {
      if (!trackingTouch) return;
      trackingTouch = false;
      release();
    };

    const onWindowScroll = () => {
      if (window.scrollY > 2 && (pull > 0 || reveal.classList.contains('is-pulling'))) {
        trackingTouch = false;
        release();
      }
    };

    const onOrientationChange = () => window.setTimeout(positionReveal, 120);

    positionReveal();
    window.addEventListener('touchstart', onTouchStart, { passive: true });
    window.addEventListener('touchmove', onTouchMove, { passive: false });
    window.addEventListener('touchend', onTouchEnd, { passive: true });
    window.addEventListener('touchcancel', onTouchEnd, { passive: true });
    window.addEventListener('resize', positionReveal, { passive: true });
    window.addEventListener('orientationchange', onOrientationChange, { passive: true });
    window.addEventListener('scroll', onWindowScroll, { passive: true });

    window.__sharpMobilePullRefreshCleanup = () => {
      window.clearTimeout(releaseTimer);
      window.removeEventListener('touchstart', onTouchStart);
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', onTouchEnd);
      window.removeEventListener('touchcancel', onTouchEnd);
      window.removeEventListener('resize', positionReveal);
      window.removeEventListener('orientationchange', onOrientationChange);
      window.removeEventListener('scroll', onWindowScroll);
      reveal.classList.remove('is-pulling');
      reveal.style.setProperty('--sharp-egg-opacity', '0');
      reveal.style.setProperty('--sharp-egg-travel', '0px');
      reveal.style.setProperty('--sharp-egg-scale', '.96');
    };
  };

  if (isMobileTouch) {
    const scheduleMobileSetup = () => {
      window.requestAnimationFrame(setupMobilePullRefresh);
      window.setTimeout(setupMobilePullRefresh, 160);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleMobileSetup, { once: true });
    } else {
      scheduleMobileSetup();
    }

    document.addEventListener('shopify:section:load', () => window.setTimeout(setupMobilePullRefresh, 40));
    return;
  }

  if (!isSafari) return;

  const restore = () => {
    if (typeof window.__sharpCrossBrowserEggCleanup === 'function') {
      window.__sharpCrossBrowserEggCleanup();
      window.__sharpCrossBrowserEggCleanup = null;
    }

    document.documentElement.classList.remove('sharp-chrome-easter-egg');
    document.getElementById('sharp-cross-browser-overscroll-style')?.remove();

    const wrapper = document.querySelector('.header-wrapper');
    const header = wrapper?.querySelector('header') || document.querySelector('header.header');
    const logo = header?.querySelector('.header__heading-link, .header__heading-logo-wrapper');
    const reveal = wrapper?.querySelector('.sharp-overscroll-easter-egg');

    if (!wrapper || !header || !logo || !reveal) return;

    reveal.classList.remove('is-pulling');
    reveal.style.removeProperty('--sharp-egg-opacity');
    reveal.style.removeProperty('--sharp-egg-travel');

    const wrapperRect = wrapper.getBoundingClientRect();
    const headerRect = header.getBoundingClientRect();
    const logoRect = logo.getBoundingClientRect();
    const left = logoRect.left + (logoRect.width / 2) - wrapperRect.left;
    const top = headerRect.bottom - wrapperRect.top + 7;

    reveal.style.setProperty('--sharp-egg-left', `${Math.round(left)}px`);
    reveal.style.setProperty('--sharp-egg-top', `${Math.round(top)}px`);
  };

  const scheduleRestore = () => {
    window.setTimeout(restore, 0);
    window.setTimeout(restore, 160);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRestore, { once: true });
  } else {
    scheduleRestore();
  }

  window.addEventListener('resize', restore, { passive: true });
  window.addEventListener('orientationchange', () => window.setTimeout(restore, 120), { passive: true });
  document.addEventListener('shopify:section:load', () => window.requestAnimationFrame(scheduleRestore));
})();
